module.exports = "<div class=\"sidebar\">\n  <app-sidebar-header></app-sidebar-header>\n  <app-sidebar-form></app-sidebar-form>\n  <app-suppliersidebar-nav></app-suppliersidebar-nav>\n  <app-sidebar-footer></app-sidebar-footer>\n  <app-sidebar-minimizer></app-sidebar-minimizer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/portaldev/bullseye/src/app/components/app-suppliersidebar/app-suppliersidebar.component.html
// module id = ../../../../../src/app/components/app-suppliersidebar/app-suppliersidebar.component.html
// module chunks = main